import React, { useState, useEffect } from "react";
import { Container, Row, Col, Table, Button, Spinner, Alert, Badge } from "react-bootstrap";
import { FaEdit, FaPrint, FaArrowLeft, FaTruck } from "react-icons/fa";
import { useParams, useNavigate, Link } from "react-router-dom";
import api from "../services/api";
import "./AddPurchase.css";

const ViewDeliveryNote = () => {
  const [deliveryNote, setDeliveryNote] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    fetchDeliveryNoteData();
  }, [id]);

  const fetchDeliveryNoteData = async () => {
    try {
      setLoading(true);
      setError("");
      
      const response = await api.post("/delivery_note_detail.php", { id });
      
      if (response.data.head.code === 200) {
        setDeliveryNote(response.data.body);
      } else {
        setError(response.data.head.msg || "Delivery note not found");
        setDeliveryNote(null);
      }
    } catch (err) {
      console.error("Error fetching delivery note:", err);
      setError("Failed to load delivery note. Please try again.");
      setDeliveryNote(null);
    } finally {
      setLoading(false);
    }
  };

  const handlePrint = () => {
    window.open(`/deliverynoteprint/${deliveryNote.id}`, '_blank');
  };

/*
  const handlePrint = () => {
    if (deliveryNote) {
      const printWindow = window.open('', '_blank');
      printWindow.document.write(`
        <html>
          <head>
            <title>Delivery Note DN-${deliveryNote.id}</title>
            <style>
              body { font-family: Arial, sans-serif; padding: 20px; }
              .header { text-align: center; margin-bottom: 30px; }
              .company-name { font-size: 24px; font-weight: bold; }
              .delivery-title { font-size: 20px; margin: 10px 0; }
              .section { margin-bottom: 20px; }
              .section-title { font-weight: bold; border-bottom: 1px solid #000; padding-bottom: 5px; margin-bottom: 10px; }
              table { width: 100%; border-collapse: collapse; margin: 20px 0; }
              th, td { border: 1px solid #000; padding: 8px; text-align: left; }
              th { background-color: #f2f2f2; }
              .totals { float: right; margin-top: 20px; }
              .total-row { margin-bottom: 5px; }
              .grand-total { font-weight: bold; font-size: 18px; margin-top: 10px; }
              @media print { .no-print { display: none; } }
            </style>
          </head>
          <body>
            <div class="header">
              <div class="company-name">Sri Kumaran Traders</div>
              <div class="delivery-title">DELIVERY NOTE</div>
              <div>Delivery Note #: DN-${deliveryNote.id}</div>
              <div>Date: ${deliveryNote.date}</div>
              <div>Status: ${deliveryNote.status}</div>
            </div>
            
            <div class="section">
              <div class="section-title">Customer Details</div>
              <div><strong>Name:</strong> ${deliveryNote.customer_name || "N/A"}</div>
              <div><strong>Phone:</strong> ${deliveryNote.customer_phone || "N/A"}</div>
              <div><strong>Address:</strong> ${deliveryNote.customer_address || "N/A"}</div>
              <div><strong>GST No:</strong> ${deliveryNote.customer_gst_no || "N/A"}</div>
            </div>
            
            <div class="section">
              <div class="section-title">Delivery Details</div>
              <div><strong>Invoice Reference:</strong> ${deliveryNote.invoice_no || "N/A"}</div>
              <div><strong>Delivery Address:</strong> ${deliveryNote.delivery_address || "Same as above"}</div>
              <div><strong>Vehicle No:</strong> ${deliveryNote.vehicle_no || "N/A"}</div>
              <div><strong>Driver Name:</strong> ${deliveryNote.driver_name || "N/A"}</div>
              <div><strong>Driver Phone:</strong> ${deliveryNote.driver_phone || "N/A"}</div>
            </div>
            
            <table>
              <thead>
                <tr>
                  <th>S.No</th>
                  <th>Product Code</th>
                  <th>Description</th>
                  <th>Ordered Qty</th>
                  <th>Delivered Qty</th>
                  <th>Pending Qty</th>
                </tr>
              </thead>
              <tbody>
                ${deliveryNote.items && deliveryNote.items.map((item, index) => `
                  <tr>
                    <td>${index + 1}</td>
                    <td>${item.product_code}</td>
                    <td>Product Item</td>
                    <td>${item.order_qty}</td>
                    <td>${item.delivery_qty}</td>
                    <td>${item.pending_qty}</td>
                  </tr>
                `).join('')}
              </tbody>
              <tfoot>
                <tr>
                  <td colspan="3" class="text-end fw-bold">Totals:</td>
                  <td class="fw-bold">
                    ${deliveryNote.items?.reduce((sum, item) => sum + (parseInt(item.order_qty) || 0), 0) || 0}
                  </td>
                  <td class="fw-bold">
                    ${deliveryNote.items?.reduce((sum, item) => sum + (parseInt(item.delivery_qty) || 0), 0) || 0}
                  </td>
                  <td class="fw-bold">
                    ${deliveryNote.items?.reduce((sum, item) => sum + (parseInt(item.pending_qty) || 0), 0) || 0}
                  </td>
                </tr>
              </tfoot>
            </table>
            
            ${deliveryNote.notes ? `
            <div class="section">
              <div class="section-title">Notes</div>
              <div>${deliveryNote.notes}</div>
            </div>
            ` : ''}
            
            <div style="clear: both; margin-top: 50px; padding-top: 20px; border-top: 1px solid #000;">
              <div style="float: left; width: 50%;">
                <div><strong>Customer Signature</strong></div>
                <div style="margin-top: 50px;">_____________________</div>
              </div>
              <div style="float: right; width: 50%; text-align: right;">
                <div><strong>Driver Signature</strong></div>
                <div style="margin-top: 50px;">_____________________</div>
              </div>
            </div>
            
            <script>
              window.onload = function() {
                window.print();
                setTimeout(function() { window.close(); }, 1000);
              }
            </script>
          </body>
        </html>
      `);
    }
  };
*/
  const getStatusVariant = (status) => {
    switch(status) {
      case 'Delivered': return 'success';
      case 'In Transit': return 'info';
      case 'Pending': return 'warning';
      case 'Cancelled': return 'danger';
      default: return 'secondary';
    }
  };

  if (loading) {
    return (
      <Container className="mt-4">
        <div className="text-center py-5">
          <Spinner animation="border" variant="primary" />
          <p className="mt-3">Loading delivery note...</p>
        </div>
      </Container>
    );
  }

  if (error || !deliveryNote) {
    return (
      <Container className="mt-4">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h4 className="mb-0">Delivery Note Details</h4>
          <Button className="btn-top" onClick={() => navigate("/deliverynote")}>
            <FaArrowLeft className="me-2" /> Back to List
          </Button>
        </div>
        <Alert variant="danger">
          {error || "Delivery note not found."}
        </Alert>
        <div className="text-center mt-4">
          <Button variant="primary" onClick={() => navigate("/deliverynote")}>
            Go to Delivery Note List
          </Button>
        </div>
      </Container>
    );
  }

  // Calculate totals
  const totalOrderedQty = deliveryNote.items?.reduce((total, item) => 
    total + (parseInt(item.order_qty) || 0), 0) || 0;
  const totalDeliveredQty = deliveryNote.items?.reduce((total, item) => 
    total + (parseInt(item.delivery_qty) || 0), 0) || 0;
  const totalPendingQty = deliveryNote.items?.reduce((total, item) => 
    total + (parseInt(item.pending_qty) || 0), 0) || 0;

  return (
    <Container className="mt-4">
      {/* Header Section */}
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h4 className="mb-0">Delivery Note Details</h4>
        <div className="d-flex gap-2">
          <Button className="btn-submit" onClick={handlePrint}>
            <FaPrint className="me-2" /> Print
          </Button>
          {/* <Link
            to={`/editdeliverynote/${deliveryNote.id}`}
            className="btn-submit d-inline-flex align-items-center"
          >
            <FaEdit className="me-2" /> Edit
          </Link> */}
          <Button className="btn-top" onClick={() => navigate("/deliverynote")}>
            <FaArrowLeft className="me-2" /> Back
          </Button>
        </div>
      </div>

      {/* Delivery Note ID, Date and Status Section */}
      <div className="p-4 border rounded bg-light mb-4">
        <Row>
          <Col lg={4} md={4} sm={12}>
            <div className="mb-3">
              <strong>Delivery Note No:</strong>
              <div className="fs-5 text-primary d-flex align-items-center">
                <FaTruck className="me-2" />
                {deliveryNote.id}
              </div>
            </div>
          </Col>
          <Col lg={4} md={4} sm={12}>
            <div className="mb-3">
              <strong>Date:</strong>
              <div className="fs-5">{deliveryNote.date}</div>
            </div>
          </Col>
          <Col lg={4} md={4} sm={12}>
            <div className="mb-3">
              <strong>Bundel Count:</strong>
              <div>
                <Badge bg={getStatusVariant(deliveryNote.bundel_count)} className="fs-6">
                  {deliveryNote.bundel_count || "Pending"}
                </Badge>
              </div>
            </div>
          </Col>
          {deliveryNote.invoice_no && (
            <Col lg={4} md={4} sm={12}>
              <div className="mb-3">
                <strong>Invoice Reference:</strong>
                <div className="fs-6">INV-{deliveryNote.invoice_no}</div>
              </div>
            </Col>
          )}
          {deliveryNote.vehicle_no && (
            <Col lg={4} md={4} sm={12}>
              <div className="mb-3">
                <strong>Vehicle No:</strong>
                <div className="fs-6">{deliveryNote.vehicle_no}</div>
              </div>
            </Col>
          )}
        </Row>
      </div>

      {/* Customer Details Section */}
      <div className="p-4 border rounded bg-light mb-4">
        <h5 className="mb-3">Customer Details</h5>
        <Row>
          <Col lg={6} md={6} sm={12}>
            <div className="mb-3">
              <strong>Customer Name:</strong>
              <div className="fs-5">{deliveryNote.customer_name || "N/A"}</div>
            </div>
          </Col>
          <Col lg={6} md={6} sm={12}>
            <div className="mb-3">
              <strong>Phone Number:</strong>
              <div className="fs-5">{deliveryNote.customer_phone || "N/A"}</div>
            </div>
          </Col>
          <Col lg={6} md={6} sm={12}>
            <div className="mb-3">
              <strong>GST Number:</strong>
              <div className="fs-6">{deliveryNote.customer_gst_no || "N/A"}</div>
            </div>
          </Col>
          <Col lg={6} md={6} sm={12}>
            <div className="mb-3">
              <strong>Address:</strong>
              <div className="fs-6">
                {deliveryNote.customer_address || "N/A"} {deliveryNote.customer_city && `, ${deliveryNote.customer_city}`}
                {deliveryNote.customer_state && `, ${deliveryNote.customer_state}`}
                {deliveryNote.customer_pin_code && ` - ${deliveryNote.customer_pin_code}`}
              </div>
            </div>
          </Col>
        </Row>
      </div>

      {/* Delivery Details Section */}
      <div className="p-4 border rounded bg-light mb-4">
        <h5 className="mb-3">Delivery Details</h5>
        <Row>
          <Col lg={6} md={6} sm={12}>
            <div className="mb-3">
              <strong>Delivery Address:</strong>
              <div className="fs-6">
                {deliveryNote.delivery_address || deliveryNote.customer_address || "N/A"}
              </div>
            </div>
          </Col>
          <Col lg={6} md={6} sm={12}>
            <div className="mb-3">
              <strong>Driver Name:</strong>
              <div className="fs-6">{deliveryNote.driver_name || "N/A"}</div>
            </div>
          </Col>
          <Col lg={6} md={6} sm={12}>
            <div className="mb-3">
              <strong>Driver Phone:</strong>
              <div className="fs-6">{deliveryNote.driver_phone || "N/A"}</div>
            </div>
          </Col>
          <Col lg={6} md={6} sm={12}>
            <div className="mb-3">
              <strong>Vehicle No:</strong>
              <div className="fs-6">{deliveryNote.vehicle_no || "N/A"}</div>
            </div>
          </Col>
        </Row>
      </div>

      {/* Delivery Items Table */}
      <div className="table-responsive mb-4">
        <Table bordered className="purchase-table">
          <thead className="table-dark">
            <tr>
              <th width="5%" className="text-center">S.No</th>
              {/* <th width="15%">Product Code</th> */}
              <th width="25%">Item</th>
              <th width="15%" className="text-center">Rate</th>
              <th width="15%" className="text-center">Delivered Qty</th>
              <th width="15%" className="text-center">Total</th>
            </tr>
          </thead>
          <tbody>
            {deliveryNote.items && deliveryNote.items.map((item, index) => (
              <tr key={index}>
                <td className="text-center">{index + 1}</td>
                {/* <td>{item.product_code}</td> */}
                <td>{item.name}</td>
                <td className="text-center">{item.selling_rate}</td>
                <td className="text-center">{item.delivery_qty}</td>
                {/* <td className="text-center">
                  <span className={item.pending_qty > 0 ? "text-warning fw-bold" : "text-success"}>
                    {item.pending_qty}
                  </span>
                </td> */}
                <td className="text-center">{item.total}</td>
              </tr>
            ))}
            {(!deliveryNote.items || deliveryNote.items.length === 0) && (
              <tr>
                <td colSpan="6" className="text-center text-muted py-3">
                  No items found
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>

      {/* Totals Section */}
      <Row className="mt-4">
              <Col xs={12} className="d-flex justify-content-end">
                <div className="totals-section">
                  <div className="total-row">
                    <span className="total-label">Subtotal:</span>
                    <span className="total-value">₹{parseFloat(deliveryNote.sub_total).toFixed(2)}</span>
                  </div>
                  <div className="total-row">
                    <span className="total-label">
                      GST ({deliveryNote.gst_per}%)
                    </span>
                    <span className="total-value">₹{parseFloat(deliveryNote.gst_amount).toFixed(2)}</span>
                  </div>
                  <div className="total-row grand-total">
                    <span className="total-label">Grand Total:</span>
                    <span className="total-value">₹{parseFloat(deliveryNote.total).toFixed(2)}</span>
                  </div>
                </div>
              </Col>
            </Row>

      {/* Notes Section */}
      {deliveryNote.notes && (
        <div className="p-4 border rounded bg-light mt-4">
          <h5>Notes</h5>
          <p>{deliveryNote.notes}</p>
        </div>
      )}

      {/* Action Buttons 
      <div className="d-flex justify-content-end mt-4 gap-2">
        <Button className="btn-top" onClick={handlePrint}>
          <FaPrint className="me-2" /> Print Delivery Note
        </Button>
        <Link
          to={`/editdeliverynote/${deliveryNote.id}`}
          className="btn-submit d-inline-flex align-items-center"
        >
          <FaEdit className="me-2" /> Edit Delivery Note
        </Link>
        <Button className="btn-top" onClick={() => navigate("/deliverynote")}>
          <FaArrowLeft className="me-2" /> Back to List
        </Button>
      </div>
*/}
      {/* Footer */}
      <div className="text-center mt-5 pt-3 border-top">
        <small className="text-muted">
          Created: {new Date(deliveryNote.created_at).toLocaleString()} | 
          {deliveryNote.updated_at !== deliveryNote.created_at && ` Updated: ${new Date(deliveryNote.updated_at).toLocaleString()} |`}
          Copyright © Sri Kumaran Traders
        </small>
      </div>
    </Container>
  );
};

export default ViewDeliveryNote;